"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRuleStateDefinition = void 0;
const selector_1 = require("./selector");
const pseudo_states_1 = require("../pseudo-states");
const features_1 = require("../features");
function validateRuleStateDefinition(rule, meta, resolver, diagnostics) {
    const parentRule = rule;
    const selectorAst = (0, selector_1.parseSelectorWithCache)(parentRule.selector);
    if (selectorAst.length && selectorAst.length === 1) {
        const singleSelectorAst = selectorAst[0];
        const selectorChunk = singleSelectorAst.nodes;
        if (selectorChunk.length === 1 && selectorChunk[0].type === 'class') {
            const className = selectorChunk[0].value;
            const classMeta = features_1.CSSClass.get(meta, className);
            const states = classMeta === null || classMeta === void 0 ? void 0 : classMeta[`-st-states`];
            if (states && classMeta._kind === 'class') {
                for (const stateName in states) {
                    // TODO: Sort out types
                    const state = states[stateName];
                    if (state && typeof state === 'object') {
                        const { errors } = (0, pseudo_states_1.validateStateArgument)(state, meta, state.defaultValue || '', resolver, diagnostics, parentRule, true, !!state.defaultValue);
                        if (errors) {
                            errors.unshift(`pseudo-state "${stateName}" default value "${state.defaultValue}" failed validation:`);
                            rule.walkDecls((decl) => {
                                if (decl.prop === `-st-states`) {
                                    diagnostics.warn(decl, errors.join('\n'), {
                                        word: decl.value,
                                    });
                                    return false;
                                }
                                return;
                            });
                        }
                    }
                }
            }
            else {
                // TODO: error state on non-class
            }
        }
    }
}
exports.validateRuleStateDefinition = validateRuleStateDefinition;
//# sourceMappingURL=custom-state.js.map